import autolinker from 'autolinker';
import React from "react";
import {escapeDisallowedTags, sanitizeMetadataHtml} from "./sanitizeMetadataHtml";

// Render free-text metadata with simple formatting HTML and linked URLs/emails:
// 1. escape every "<" that doesn't start an allow-listed tag, so text like
//    "<some text>" displays literally instead of vanishing as an unknown tag;
// 2. autolink bare URLs/emails (Autolinker skips text already inside <a>);
// 3. sanitize with DOMPurify (allow-listed tags, http/https/mailto/tel hrefs only).
export const autoLinkText = (text, opts = {}) => {
    const linked = autolinker.link(escapeDisallowedTags(text), {newWindow: true, ...opts})
    return sanitizeMetadataHtml(linked)
}

export default ({text, ...props}) => {
    try {
        const linkedText = autoLinkText(text, props)

        return <div dangerouslySetInnerHTML={{__html: linkedText}}/>
    } catch(e) {
        return <>{text}</>
    }
}
